import {Routes} from '@angular/router';
import {AuthenticatedGuard} from '@app/shared/auth/authenticated.guard';
import {UnauthenticatedGuard} from '@app/shared/auth/unauthenticated.guard';
import {ForgotPasswordComponent} from '@app/auth/auth-components/forgot-password/forgot-password.component';
import {LoginComponent} from './auth-components/login/login.component';
import {ResetPasswordComponent} from './auth-components/reset-password/reset-password.component';
import {AuthLayoutComponent} from './auth-components/auth-layout/auth-layout.component';
import {PasswordResetAllowGuard} from '@app/shared/auth/password-reset-allow.guard';
import { RegisterComponent } from './auth-components/register/register.component';
import { ConfirmEmailComponent } from './auth-components/confirm-email/confirm-email.component';
import { MagicLinkComponent } from './magic-link/magic-link.component';

export const AuthRoutes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      {
        path: 'login',
        component: LoginComponent, canActivate: [UnauthenticatedGuard]
      },
      {
        path: 'forgot-password', component: ForgotPasswordComponent,
        canActivate: [UnauthenticatedGuard]
      },
      {
        path: 'reset-password/:token',
        component: ResetPasswordComponent, 
        canActivate: [UnauthenticatedGuard]
        // canActivate: [AuthenticatedGuard, PasswordResetAllowGuard]
      },
      {
        path: 'magic-link/:token',
        component: MagicLinkComponent, 
        canActivate: [UnauthenticatedGuard]
      },
      {
        path: 'set-password',
        component: ResetPasswordComponent, 
        canActivate: [AuthenticatedGuard, PasswordResetAllowGuard]
      },
      // TODO:
      // {
      //   path: 'register',
      //   component: RegisterComponent, canActivate: [UnauthenticatedGuard]
      // },
      // {
      //   path: 'confirm-email',
      //   component: ConfirmEmailComponent, canActivate: [UnauthenticatedGuard]
      // }
    ]
  },
];
